(ns ui.editors.nev-view-editor.model
  (:require
   [ui.util :as uu]
   [potpuri.core :as p]
   [common.localization :as loc]
   [ui.view.card.model :as card-model]))

(def root-path [::state])

(def visible-path [:visible?])
(def visible-full-path (vec (concat root-path visible-path)))

(def submitting-path [:submitting?])
(def submitting-full-path (vec (concat root-path submitting-path)))

(def entity-type-path [:entity-type])
(def entity-type-full-path (vec (concat root-path entity-type-path)))

(def primary-entity-type-key :primary-entity-type)
(def primary-entity-type-path (conj root-path primary-entity-type-key))

(def view-id-path [:view-id])
(def view-id-full-path (vec (concat root-path view-id-path)))

(def entities-path [:entities])
(def entities-full-path (vec (concat root-path entities-path)))

(def location-path [:location])
(def location-full-path (vec (concat root-path location-path)))

(def create-new-view-path [:create-new-view?])
(def create-new-view-full-path (vec (concat root-path create-new-view-path)))

(def clone-view-path [:clone-view?])
(def clone-view-full-path (vec (concat root-path clone-view-path)))

(def update-view-path [:update-view?])
(def update-view-full-path (vec (concat root-path update-view-path)))

(def changes-to-cards-path [:changes-to-cards?])
(def changes-to-cards-full-path (vec (concat root-path changes-to-cards-path)))

(def view-editor-tab-path [:view-editor-tab])
(def view-editor-tab-full-path (vec (concat root-path view-editor-tab-path)))

(def sidebar-tab-path [:sidebar-tab])
(def sidebar-tab-full-path (into root-path sidebar-tab-path))

(def selected-section-path [:selected-section])
(def selected-section-full-path (into root-path selected-section-path))

(def add-card-wizard-step-path [:add-card-wizard-step])
(def add-card-wizard-step-full-path (vec (concat root-path add-card-wizard-step-path)))

(def save-view-success-callback-event-path [:save-view-success-callback-event])
(def save-view-success-callback-event-full-path (vec (concat root-path save-view-success-callback-event-path)))

(def disable-view-success-callback-event-path [:disable-view-success-callback-event])
(def disable-view-success-callback-event-full-path (vec (concat root-path disable-view-success-callback-event-path)))

(def preview-entity-id-path [:preview-entity-id])
(def preview-entity-id-full-path (vec (concat root-path preview-entity-id-path)))

(def preview-device-key :preview-device)
(def preview-device-full-path (conj root-path preview-device-key))

(def card-states-path [:card-states])
(def card-states-full-path (vec (concat root-path card-states-path)))

(def preview-card-state-path [:preview-card-state])
(def preview-card-state-full-path (vec (concat root-path preview-card-state-path)))

(def add-card-wizard-card-type-path [:add-card-wizard-card-type])
(def add-card-wizard-card-type-full-path (vec (concat root-path add-card-wizard-card-type-path)))

(def preview-state-path [:preview-state])
(def preview-state-full-path (vec (concat root-path preview-state-path)))

(def selected-top-level-section-id-key :selected-top-level-section)
(def selected-top-level-section-id-path (conj root-path selected-top-level-section-id-key))

(def selected-top-level-section-entity-type-key :selected-top-level-section-entity-type)
(def selected-top-level-section-entity-type-path (conj root-path selected-top-level-section-entity-type-key))

(defn create-default-view-entity
  [{:keys [view-temp-id entity-type account-id]}]
  {:db/id view-temp-id
   :common/owner account-id
   :entity/type :entity.type/view
   :view/type :view.type/single-entity
   :view/entity-type entity-type
   :view/cards #{}
   :view/configuration {}
   :view/access-level :view.access-level/private})

;; TODO create official acme inc preview entity that can be used elsewhere
(def preview-card-state
  {:entities {"acme-inc" {:db/id "acme-inc"
                          :asset/name "Acme inc"
                          :asset/description "Acme is a technology company based in San Francisco."}}
   :loading? false})

(defn get-entity
  [db entity-id]
  (get-in db (conj entities-full-path entity-id)))

(defn get-view-entity
  [db]
  (let [view-id (get-in db view-id-full-path)]
    (get-entity db view-id)))

(defn get-cards-db
  [db]
  (let [view-entity (get-view-entity db)
        cards (->> view-entity
                   :view/cards
                   (mapv (fn [card-id]
                           (get-entity db card-id))))]
    cards))

(defn merge-entities
  [db entities-by-id]
  (update-in db entities-full-path merge entities-by-id))

(defn merge-entity
  [db entity]
  (merge-entities db {(:db/id entity) entity}))

(defn set-view-entity
  [db view-entity]
  (let [view-id (:db/id view-entity)]
    (-> db
        (assoc-in view-id-full-path view-id)
        (merge-entities {view-id view-entity}))))

(defn close-editor
  [db]
  (p/dissoc-in db root-path))

(defn ->preview-card-state-path
  [card-id]
  (conj card-states-path card-id))

(defn ->preview-card-state-full-path
  [card-id]
  (vec (concat root-path (->preview-card-state-path card-id))))

(defn reset-card-states-db
  [db]
  (let [view-id (get-in db view-id-full-path)
        view-entity (get-in db (conj entities-full-path view-id))
        card-ids (:view/cards view-entity)
        card-states (->> card-ids
                         (map (fn [card-id]
                                (let [card (get-in db (conj entities-full-path card-id))
                                      state (card-model/create-initial-card-state {:card card})]
                                  [card-id state])))
                         (into {}))]
    (assoc-in db card-states-full-path card-states)))

(def preview-device-options
  [{:value :desktop
    :label (loc/tr :desktop)
    :icon-class "fas fa-desktop-alt"
    :width "100%"}
   {:value :laptop
    :label (loc/tr :laptop)
    :icon-class "fas fa-laptop"
    :width "1000px"}
   {:value :mobile
    :label (loc/tr :mobile)
    :icon-class "fas fa-mobile-alt"
    :width "450px"}])
